module.exports = __webpack_public_path__ + "img/Background.8ee206c1.jpg";